export default __webpack_public_path__ + "static/media/poster-movie-title.9ee17128.png";